import { IMenu } from "../models";


export class ModuleNavigatedMessage {
    public header: any;
    public menu: any;
  
    constructor(header?: any, menu?: any) {
      this.header = header;
      this.menu = menu;
    }
  }
  